<template>
  <div class="homeleft">
    <div class="listai">
      <List item-layout="vertical" v-if="tindex==1">
        <ListItem v-for="item in data1" :key="item.title">
          <router-link style="color:#575f73;" :to="{path: item.path}">
            <template class="newarticle">
              <span v-if="item.newimg == '最新'">{{item.newimg}}</span>
            </template>
            <ListItemMeta :avatar="item.avatar" :title="item.title" :description="item.description" /> {{ item.content }}</router-link>
          <template slot="action">
            <li>
              <Icon type="ios-star-outline" /> 123
            </li>
            <li>
              <Icon type="ios-thumbs-up-outline" /> 234
            </li>
            <li>
              <Icon type="ios-chatbubbles-outline" /> 345
            </li>
          </template>
          <template slot="extra">
            <img :src="item.srcs" style="width: 280px">
          </template>
        </ListItem>
      </List>
      <List item-layout="vertical" v-if="tindex==2">
        <ListItem v-for="item in data2" :key="item.title">
          <router-link style="color:#575f73;" :to="{path: item.path}">
            <ListItemMeta :avatar="item.avatar" :title="item.title" :description="item.description" /> {{ item.content }}</router-link>
          <template slot="action">
            <li>
              <Icon type="ios-star-outline" /> 123
            </li>
            <li>
              <Icon type="ios-thumbs-up-outline" /> 234
            </li>
            <li>
              <Icon type="ios-chatbubbles-outline" /> 345
            </li>
          </template>
          <template slot="extra">
            <img :src="item.srcs" style="width: 280px">
          </template>
        </ListItem>
      </List>
      <List item-layout="vertical" v-if="tindex==3">
        <ListItem v-for="item in data3" :key="item.title">
          <router-link style="color:#575f73;" :to="{path: item.path}">
            <ListItemMeta :avatar="item.avatar" :title="item.title" :description="item.description" /> {{ item.content }}</router-link>
          <template slot="action">
            <li>
              <Icon type="ios-star-outline" /> 123
            </li>
            <li>
              <Icon type="ios-thumbs-up-outline" /> 234
            </li>
            <li>
              <Icon type="ios-chatbubbles-outline" /> 345
            </li>
          </template>
          <template slot="extra">
            <img :src="item.srcs" style="width: 280px">
          </template>
        </ListItem>
      </List>
      <List item-layout="vertical" v-if="tindex==4">
        <ListItem v-for="item in data3" :key="item.title">
          <router-link style="color:#575f73;" :to="{path: item.path}">
            <ListItemMeta :avatar="item.avatar" :title="item.title" :description="item.description" /> {{ item.content }}</router-link>
          <template slot="action">
            <li>
              <Icon type="ios-star-outline" /> 123
            </li>
            <li>
              <Icon type="ios-thumbs-up-outline" /> 234
            </li>
            <li>
              <Icon type="ios-chatbubbles-outline" /> 345
            </li>
          </template>
          <template slot="extra">
            <img :src="item.srcs" style="width: 280px">
          </template>
        </ListItem>
      </List>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tindex"],
  data() {
    return {
      data1: [
        {
          title: "怎么起一个好听的名字？看完这篇就够了！",
          description:
            "对于广大的起名废而言，起一个音、形、义都比较好，而且适合孩子的名字真是难于上青天",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "这篇就先来分析一下音形义当中比较容易但是最感性的方面：音律。",
          path: "/artical7",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/article7.jpg"),
          newimg:"最新"
        },
        {
          title: "《起名废急救指南》第二章 第四节 了解现代汉语音韵知识 给孩子起一个好听的名字",
          description:
            "了解关于姓名的法律知识，在起名字时让你少走弯路！",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "绕口令读起来觉得很难受，就是因为绕口令不断地使用同一个部位或者相近的部位来重复发音，导致我们读起来很不舒服。",
          path: "/artical6",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/article6.jpg"),
          newimg:"最新"
        },
        {
          title:
            "《起名废急救指南》第二章 第三节 给孩子起名、改名时必须要知道的四件法律常识",
          description: "了解关于姓名的法律知识，在起名字时让你少走弯路！",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "名字是自己的社会代号，涉及面众多，不管取名还是改名，都得注意！",
          path: "/artical5",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/article5.jpg"),
          newimg: "最新"
        },
        {
          title: "《起名废急救指南》 第二章 第二节 从古人的字学起名",
          description:
            "从上一篇我们分析了姓和氏的起源及其不同，到最后演变为姓氏的统一，本章我们再来看看另外一个和姓名相关的话题",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content: "古人的名、字是完全不同的概念。",
          path: "/artical4",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/article4.jpg"),
          newimg: "最新"
        },
        {
          title: "《起名废急救指南》第二章 第一节 姓氏文化简介",
          description:
            "“姓”的本义是源于同一女性始祖，具有共同血缘关系的部族所共有的符号。",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "据统计《春秋》中有风，妫，姬，姒，子，嬴，己，任，姞，祁，芈，曹，妘，董，姜，偃，归，曼，熊，隗，漆，允等22个姓，",
          path: "/artical3",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/article3.jpg"),
          newimg: "最新"
        },
        {
          title: "《起名废急救指南》起名/取名的思维过程",
          description: "​当我们说起名或者取名时，整个思维过程是怎样的呢？",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content: "整个思维过程会涉及到如下几个方面...",
          path: "/artical2",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/guocheng1.jpg"),
          newimg: "最新"
        },
        {
          title: "《起名废急救指南》总目录",
          description:
            "姓名图谱《起名废急救指南》系列文章有多少干货，先看总目录了解！",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "大家在取名过程中面临什么痛点？我们怎么解决这些问题以及我们为什么写这本书？",
          path: "/artical1",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/title.jpg")
        },
        {
          title: "《起名废急救指南》序言",
          description: "故事先从自己讲起，为啥会诞生这本书？",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "2013年冬，我和家人站在产房外，基本上没什么交流，大家看起来都很焦急和担心...",
          path: "/articalxu",
          num: 231,
          push: 234,
          common: 599,
          srcs: require("@/assets/title1.jpg")
        }
      ],
      data2: [
        {
          title: "全国及各省姓名重名查询接口汇总",
          description:
            "这是一篇满满的干货,我们收集了全国的重名查询的网址以及查询方式。",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "帮助你查询自己的名字在全国有多少人还可以帮朋友查、帮亲戚查......",
          path: "/searchname",
          num: 23,
          push: 232,
          common: 59,
          srcs: require("@/assets/searchname.jpg")
        },
        {
          title: "派出所改名需要哪些手续和流程？",
          description:
            "很多成年人在自己长大之后，发现名字不好听，或者自己不喜欢，想改过来。具体来看！",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "改名字并非我们想象的那么简单，需要在户籍所在地更改户口上的名字，是要办理相关手续的。",
          path: "/changename",
          num: 222,
          push: 2342,
          common: 599,
          srcs: require("@/assets/changename2.jpg")
        }
      ],
      data3: [
        {
          title: "起名废系列之“李”姓拯救指南",
          description:
            "“李”姓重要特点总结如下，在起名时需要特别注意",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "“李”为上声字，在汉语中上声字有很多变调形式，两个上声字相连第一个上声字会读成阳平，所以“李果”会被读成“梨果”",
          path: "/nameatl1",
          num: 238,
          push: 264,
          common: 459,
          srcs: require("@/assets/nameatl1.jpg")
        },
        {
          title: "起名废系列之“朱”姓拯救指南",
          description:
            "“朱”姓重要特点总结如下，在起名时需要特别注意。。",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "和“朱”同音的字：猪、侏、诛、珠、蛛等要特别注意“猪”这个高频字造成的谐音",
          path: "/nameatl2",
          num: 238,
          push: 264,
          common: 459,
          srcs: require("@/assets/nameatl2.jpg")
        },
        {
          title: "起名废系列之“云”姓拯救指南",
          description:
            "“云”姓重要特点总结如下，在起名时需要特别注意。。",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "和“云”同音的字：芸、纭、匀、昀、筠和“云”姓同音的字还都比较好，没有不好的谐音字。像昀、筠在名字中也经常用。",
          path: "/nameatl3",
          num: 238,
          push: 264,
          common: 459,
          srcs: require("@/assets/nameatl3.jpg")
        },
        {
          title: "关于姓氏的20个冷知识",
          description:
            "2019年11月7日，首届中华姓氏申遗大会在福州举行，两百余名专家代表与会，推动中华姓氏申报“世界记忆遗产”。",
          avatar:
            "https://pic1.zhimg.com/v2-b218913b33dc2cd0a666fe47687e9e80_xs.jpg",
          content:
            "你想过，有一天自己的姓氏也能申遗吗？关于姓氏，你真的了解吗？",
          path: "/aboutname",
          num: 238,
          push: 264,
          common: 459,
          srcs: require("@/assets/nameabout.jpg")
        }
      ],
      // data4: [
        
      // ]
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .topMag {
    @media screen and(max-width:1200px) {
      padding: 5px 8px;
    }
    padding: 16px 20px;
    border-bottom: 1px #e8eaec solid;
  }
  .listai {
    padding: 16px;
    @media screen and(max-width:1200px) {
      padding: 5px;
    }
    span {
      display: inline-block;
      width: 40px;
      height: 20px;
      background-color: #fc8f47;
      color: #fff;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
